import { render } from "./EditListSortGroup.vue?vue&type=template&id=4c477230"
import script from "./EditListSortGroup.vue?vue&type=script&lang=js"
export * from "./EditListSortGroup.vue?vue&type=script&lang=js"

import "./EditListSortGroup.vue?vue&type=style&index=0&id=4c477230&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__